<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Insight: {{ insight.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 800px">
    <h5 class="mb-0" i18n>General Information</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Name</div>
        <div>{{ insight.name || '-' }}</div>
        <div *ngIf="insight_name_validator" class="error" i18n>Invalid!</div>
        <div class="field-label mt-3" i18n>Category</div>
        <div>{{ insight.category || '-' }}</div>
        <div class="field-label mt-3" i18n>Description</div>
        <div>{{ insight.description || '-' }}</div>
      </div>
      <div class="col">
        <div class="field-label" i18n>Status</div>
        <div>{{ statusLabel }}</div>
        <div class="field-label mt-3" i18n>Schedule</div>
        <div>{{ scheduleLabel }}</div>
        <div class="field-label mt-3" i18n>Frequency</div>
        <div>{{ frequencyLabel }}</div>
      </div>
    </div>

    <h5 class="mb-0" i18n>Insight Query</h5>
    <hr />

    <div class="mb-5">
      <ngx-codemirror
        id="query"
        name="query"
        [(ngModel)]="insight.query"
        [options]="{
          lineNumbers: true,
          theme: 'default',
          mode: 'sql',
          readOnly: 'true'
        }"
      ></ngx-codemirror>
    </div>

    <h5 class="mb-0" i18n>Metadata</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Last Run Status</div>
        <div>{{ insight.status | titlecase }}</div>
        <div class="field-label mt-3" i18n>Last Run Time</div>
        <div>{{ (insight.last_run_time | customValueHandling: 'last_run_time') || '-' }}</div>
        <div class="field-label mt-3" i18n>Next Run Time</div>
        <div>{{ (insight.next_run_time | customValueHandling: 'next_run_time') || '-' }}</div>
        <div class="field-label mt-3" i18n>Total Executions</div>
        <div>{{ insight.executions | customValueHandling: 'executions' }}</div>
        <div class="field-label mt-3" i18n>Average Execution Time</div>
        <div>{{ averageExecutionDuration | formatTime }}</div>
        <div class="field-label mt-3" i18n>Total Results</div>
        <div>{{ insight.total_results | customValueHandling: 'total_results' }}</div>
      </div>
      <div class="col">
        <div class="field-label" i18n>Created By</div>
        <div>{{ insight.created_by || '-' }}</div>
        <div class="field-label mt-3" i18n>Created On</div>
        <div>{{ (insight.created_dttm | customValueHandling: 'created_dttm') || '-' }}</div>
        <div class="field-label mt-3" i18n>Last Updated By</div>
        <div>{{ insight.last_updated_by || '-' }}</div>
        <div class="field-label mt-3" i18n>Last Updated On</div>
        <div>{{ (insight.last_updated_dttm | customValueHandling: 'last_updated_dttm') || '-' }}</div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button *ngIf="displayManagementButtons" nbButton class="ml-3" status="success" (click)="runOnce()" i18n>
        Run Once
      </button>
      <button nbButton class="ml-3" status="info" (click)="viewStats()" i18n>View Stats</button>
      <button
        *ngIf="displayManagementButtons && insight.enabled === false"
        nbButton
        class="ml-3"
        status="success"
        (click)="updateStatus('activate')"
        i18n
      >
        Activate
      </button>
      <button
        *ngIf="displayManagementButtons && insight.enabled === true"
        nbButton
        class="ml-3"
        status="danger"
        (click)="updateStatus('deactivate')"
        i18n
      >
        Deactivate
      </button>
    </div>
  </nb-card-footer>
</nb-card>
